import { Theme, createStyles } from "@material-ui/core";

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      marginTop: 20,
    },
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    modalContent: {
      margin: "auto",
      position: "relative",
      width: "40%",
      height: "auto",
      minHeight: "35%",
      backgroundColor: "#fafafa",
      justifyContent: "space-evenly",
      display: "flex",
      alignItems: "center",
      flexFlow: "column",
      borderRadius: "30px 30px 30px 30px",
      textAlign: "center",
      padding: "40px 70px 0px 90px",
      [theme.breakpoints.down("sm")]: {
        width: "95%",
        padding: "25px 10px 5px",
      },
    },
    modalIcon: {
      width: 84,
      height: 84,
      marginBottom: 35,
    },
    modalTitle: {
      fontWeight: 500,
      fontSize: 24,
      lineHeight: "28.13px",
      letterSpacing: "0%",
      textAlign: "center",
      color: "#3B465C",
      marginBottom: 15,
    },
    modalDescription: {
      fontWeight: 400,
      fontSize: 16,
      lineHeight: "18.75px",
      letterSpacing: "0%",
      textAlign: "center",
      color: "#3B465C99",
      marginBottom: 8,
    },
    modalService: {
      fontWeight: 600,
      fontSize: 16,
      lineHeight: "18.75px",
      letterSpacing: "0%",
      textAlign: "center",
      color: "#3B465C",
      marginBottom: 8,
    },
    modalButtons: {
      display: "flex",
      gap: "15px",
      height: 100,
      alignItems: "center",
    },
    modalCancel: {
      width: 160,
      height: 50,
      border: "1px solid #119BD0",
      color: "#119BD0",
      borderRadius: 15,
      boxShadow: "0px 3px 6px 0px #00000029",
    },
    modalAccept: {
      width: 160,
      height: 50,
      border: "1px solid #E34850",
      backgroundColor: "#E34850",
      color: "#fff",
      borderRadius: 15,
      boxShadow: "0px 3px 6px 0px #00000029",
    },
    modalReactivate: {
      width: 160,
      height: 50,
      border: "1px solid #004B81",
      backgroundColor: "#004B81",
      color: "#fff",
      borderRadius: 15,
      boxShadow: "0px 3px 6px 0px #00000029",
    },
    buttonContent: {
      display: "flex",
      flexDirection: "row",
    },
  });
